import React from 'react';
import { ArrowRight, MessageCircle } from 'lucide-react';
import { Button } from './ui/button';

const WHATSAPP_NUMBER = '556296481343'; // Substitua pelo número real

const Hero = ({ onOpenOrder }) => {
  const openWhatsApp = () => {
    const message = encodeURIComponent('Olá! Tenho dúvidas sobre o serviço da FEATS. Pode me ajudar?');
    window.open(`https://wa.me/${WHATSAPP_NUMBER}?text=${message}`, '_blank');
  };

  return (
    <section id="home" className="pt-24 pb-16 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-[1.05fr_0.95fr] items-center gap-12">
          <div className="max-w-2xl mx-auto lg:mx-0 text-center lg:text-left">
            <div className="inline-block mb-4 px-4 py-2 bg-gradient-to-r from-orange-100 to-yellow-100 rounded-full">
              <span className="text-orange-700 font-semibold text-sm">Nutrição Personalizada</span>
            </div>
            
            <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-gray-900 mb-6 leading-tight">
              Suas marmitas na proporção do{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-orange-600 to-yellow-600">
              seu plano nutricional
              </span>
            </h1>
            
            <p className="text-xl md:text-2xl text-gray-600 mb-8 leading-relaxed">
              Envie suas quantidades. A gente produz, porciona e entrega — tudo congelado, pronto pra semana.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start items-center lg:items-start">
              <Button 
                size="lg" 
                onClick={onOpenOrder}
                className="bg-orange-600 hover:bg-orange-700 text-white px-8 py-6 text-lg group"
              >
                Montar meu pedido
                <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" />
              </Button>
              
              <Button 
                size="lg" 
                variant="outline"
                onClick={openWhatsApp}
                className="border-2 border-green-600 text-green-600 hover:bg-green-50 px-8 py-6 text-lg"
              >
                <MessageCircle className="mr-2 h-5 w-5" />
                Tirar dúvida no WhatsApp
              </Button>
            </div>

            <div className="mt-12 grid grid-cols-1 sm:grid-cols-3 gap-6 sm:gap-8">
              <div className="text-center lg:text-left">
                <div className="text-3xl font-bold text-orange-600 mb-2">100%</div>
                <div className="text-gray-600">Conforme prescrição</div>
              </div>
              <div className="text-center lg:text-left">
                <div className="text-3xl font-bold text-orange-600 mb-2">0.1g</div>
                <div className="text-gray-600">Precisão na pesagem</div>
              </div>
              <div className="text-center lg:text-left">
                <div className="text-3xl font-bold text-orange-600 mb-2">30 dias</div>
                <div className="text-gray-600">Validade congelado</div>
              </div>
            </div>
          </div>

          <div className="relative flex justify-center lg:justify-end">
            <div
              className="absolute -inset-4 hidden lg:block rounded-[40px] bg-gradient-to-br from-orange-100 via-yellow-100 to-white opacity-70 blur-3xl"
              aria-hidden="true"
            />
            <div className="relative max-w-lg w-full rounded-[32px] overflow-hidden shadow-2xl border border-orange-100">
              <img
                src="/feats1.jpeg"
                alt="Refeições personalizadas FEATS"
                className="w-full h-full object-cover"
              />
              <div
                className="absolute inset-0 bg-gradient-to-tr from-orange-200/50 via-transparent to-yellow-100/40 mix-blend-multiply"
                aria-hidden="true"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
